import { BRAND_LUXE_ERROR, BRAND_LUXE_SECONDARY } from '../../../../pages/BrandDashboard/brandDashboardTokens';
import { ICampaignSales } from '../../../../redux/contest/types';

export const saleStatusVisual = (completed: boolean) => {
    if (completed) {
        return {
            label: 'Completed',
            bg: 'rgba(0, 253, 193, 0.05)',
            color: BRAND_LUXE_SECONDARY,
            border: 'rgba(0, 253, 193, 0.2)',
            dot: BRAND_LUXE_SECONDARY,
            pulse: false,
        };
    }
    return {
        label: 'Pending',
        bg: 'rgba(255, 115, 81, 0.08)',
        color: BRAND_LUXE_ERROR,
        border: 'rgba(255, 115, 81, 0.25)',
        dot: BRAND_LUXE_ERROR,
        pulse: true,
    };
};

export const formatSaleDiscount = (sale: ICampaignSales): string => {
    if (!sale.is_discounted || !sale.usd_price) {
        return '—';
    }
    const pct = Math.round((sale.usd_discounted_price / sale.usd_price) * 100);
    return `-${pct}%`;
};

export const formatSaleAmount = (sale: ICampaignSales): string =>
    sale.invoice?.formatted_amount_captured ?? sale.formatted_usd_price ?? '—';
